module.exports = __webpack_public_path__ + "media/images/rpc-app-image-aa38cd112d1e00932435d02e12a07761.png";